import React, { ReactChild } from 'react';

const IcInArrow: () => ReactChild = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={38} height={38} fill="none">
    <rect width={38} height={38} rx={6} fill="#1F1F1F" fillOpacity={0.05} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.81 23.25H24v1.5H13.25V14h1.5v8.188l8.72-8.72 1.06 1.061-8.72 8.72Z"
      fill="#1F1F1F"
      fillOpacity={0.75}
    />
  </svg>
);

export default IcInArrow;
